import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchStoreDetailsAPI, addStoreAPI, updateStoreAPI, deleteStoreAPI, updateStoreBranchAPI } from '../apis/stores'
import axiosClient from 'axiosClient';
import { getQueryString } from 'utilities/common';
import axiosClientStilo from 'axiosClient/indexStilo';
import { STILO } from 'utilities/constants';
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export const fetchStores = createAsyncThunk(
    'stores/fetchStores',
    async (filters, { rejectWithValue }) => {
        try {
            const res = await axiosClient.get(`/api/v1/admin/store/all?${getQueryString(filters)}`);
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const fetchStoresAPIs = createAsyncThunk(
    'stores/fetchStoresAPIs',
    async (filters, { rejectWithValue }) => {
        try {
            const res = await axiosClient.get(`/api/v1/admin/store/all?${getQueryString(filters)}`);
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)


export const fetchStoreDetails = createAsyncThunk(
    'stores/fetchStoreDetails',
    async (storeId, { rejectWithValue }) => {
        try {
            const res = await fetchStoreDetailsAPI(storeId)
            return res.store
        } catch (error) {

            return rejectWithValue(error?.response?.data)
        }
    }
)

export const addStore = createAsyncThunk(
    'stores/addStore',
    async (data, { rejectWithValue }) => {
        try {
            const res = await addStoreAPI(data)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const updateStore = createAsyncThunk(
    'stores/updateStore',
    async ({ data, storeId }, { rejectWithValue }) => {
        try {
            const res = await updateStoreAPI(data, storeId)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const updateStoreBranch = createAsyncThunk(
    'stores/updateStoreBranch',
    async ({ data, branchId }, { rejectWithValue }) => {
        try {
            const res = await updateStoreBranchAPI(data, branchId)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const deleteStore = createAsyncThunk(
    'stores/deleteStore',
    async (storeId, { rejectWithValue }) => {
        try {
            const res = await deleteStoreAPI(storeId)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const storesSlice = createSlice({
    name: 'stores',
    initialState: {
        stores: [],
        storeDetails: {},
        loading: false,
        error: null,
    },
    reducers: {

    },
    extraReducers: (builder) => {
        // Extra reducer for the fulfilled action of fetchStores
        builder.addCase(fetchStores.fulfilled, (state, action) => {
            state.loading = false;
            state.stores = action.payload;
            state.storeDetails = {}
            state.error = null;
        });

        // Extra reducer for the rejected action of fetchStores
        builder.addCase(fetchStores.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        // Extra reducer for the pending action of fetchStores
        builder.addCase(fetchStores.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(fetchStoresAPIs.fulfilled, (state, action) => {
            state.loading = false;
            state.stores = action.payload;
            state.storeDetails = {}
            state.error = null;
        });

        // Extra reducer for the rejected action of fetchStores
        builder.addCase(fetchStoresAPIs.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        // Extra reducer for the pending action of fetchStores
        builder.addCase(fetchStoresAPIs.pending, (state) => {
            state.loading = true;
        });

        // Extra reducer for the fulfilled action of fetchStoresDetails
        builder.addCase(fetchStoreDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.storeDetails = action.payload;
            state.error = null;
        });

        // Extra reducer for the rejected action of fetchStoresDetails
        builder.addCase(fetchStoreDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Extra reducer for the pending action of fetchStoresDetails
        builder.addCase(fetchStoreDetails.pending, (state) => {
            state.loading = true;
        });

        // Extra reducer for the pending action of AddStore
        builder.addCase(addStore.pending, (state) => {
            state.loading = true;
            state.error = null;
        })

        // Extra reducer for the fulfilled action of AddStore
        builder.addCase(addStore.fulfilled, (state, action) => {
            state.loading = false;
            state.addedStore = action.payload;
            state.error = null;
        });

        // Extra reducer for the rejected action of AddStore
        builder.addCase(addStore.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Extra reducer for UpdateStore
        builder
            .addCase(updateStore.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateStore.fulfilled, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateStore.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

        builder
            .addCase(updateStoreBranch.pending, (state, action) => {
                state.loading = true;
                state.error = null
            })
            .addCase(updateStoreBranch.fulfilled, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateStoreBranch.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export const { } = storesSlice.actions;

export default storesSlice.reducer;